var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKlicklyLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#klicklyLogo_svg__a)",
  fillRule: "evenodd",
  d: "M25.766 69.218h-3.833V61.82h-3.567v-7.273h-3.7v-7.276h-3.7v-3.895H7V31.949h11.498v3.895h3.435V3.636h4.098v48.182H21.8V39.482h-3.83l.131-3.637h-6.739v7.271h3.302v3.767h3.701v7.403h3.567v7.401h3.833v7.532h3.702v7.014h30.526v-7.014h3.57V57.921h3.7v11.297h-3.57V80H25.766zm.397-65.582V0h7.4v3.636zm11.498 33.116h-4.099V3.636h4.362v14.416h7.268v3.634h10.97v3.897h7.667v3.505h3.57v3.64h-3.57V29.22h-4.1v10.517H56.16V25.715h-7.14v10.52h-3.83V21.948H37.66v14.804m29.737 21.17V32.856h4.226v25.066z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "klicklyLogo_svg__a",
  x1: 73.369,
  x2: -6.723,
  y1: -38.431,
  y2: 99.014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A0A0A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.099,
  stopColor: "#FFF0A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "gold"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.796,
  stopColor: "#FF41F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF33FF"
})))));
export default SvgKlicklyLogo;